import React from 'react';
export var ThemeContext = /*#__PURE__*/React.createContext();